import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService, GroupService, UserService} from "../services";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {first} from "rxjs/operators";
import {ComponentTitleService} from "../services/componentTitle.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {CardService} from "../services/card.service";

@Component({
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private cardService: CardService,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Cards');

        this.translationLoader.loadTranslations(polish, english);

        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.cardService.findAll().pipe(first())
            .subscribe( res => {
                    this.rows = res;
                    this.loadingIndicator = false;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
